"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("circle", { cx: "18", cy: "18", r: "4.1" }),
  React.createElement("circle", { cx: "30", cy: "18", r: "4.1" }),
  React.createElement("circle", { cx: "6", cy: "18", r: "4.1" })
);

